/* Keep the app's category selection and structured data as the source of truth. */
if (!customElements.get('pdp-category-links')) {
  customElements.define('pdp-category-links', class extends HTMLElement {
    connectedCallback() {
      this.connectSource = () => {
        this.observer?.disconnect();
        this.signature = '';
        this.source = document.getElementById('uncomplicated-breadcrumbs');
        if (!this.source) { this.hidden = true; return; }
        this.updateLinks();
        this.observer = new MutationObserver(() => this.updateLinks());
        this.observer.observe(this.source, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['href']
        });
      };
      this.connectSource();
      document.addEventListener('shopify:section:load', this.connectSource);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('shopify:section:load', this.connectSource);
    }

    updateLinks() {
      const categories = Array.from(this.source.querySelectorAll('a.breadcrumb__branch[href]'))
        .filter(link => /\/collections\/(?!all(?:[/?#]|$))[^/?#]+/.test(link.getAttribute('href')));
      if (!categories.length) {
        this.hidden = true;
        this.signature = '';
        return;
      }

      const leaf = categories[categories.length - 1];
      const root = categories[0];
      const selected = leaf.href === root.href ? [leaf] : [root, leaf];
      const signature = JSON.stringify(selected.map(link => [link.href, link.textContent.trim()]));
      if (signature === this.signature) return;
      this.signature = signature;
      const links = selected.map(source => {
        const link = document.createElement('a');
        link.href = source.getAttribute('href');
        const label = source.textContent.trim();
        link.textContent = label === 'E-bralniki' ? 'E-bralnik' : label;
        return link;
      });
      this.querySelector('nav').replaceChildren(...links);
      this.hidden = false;
    }
  });
}
